import { createSelector } from "reselect";
import {
  getSpread,
  getSpreadBalanceSheetDocumentExceptions,
  getSpreadCashFlowDocumentExceptions,
  getSpreadIncomeStatementDocumentExceptions
} from "../spread/selector";
import {
  buildBalanceSheetAccountDescriptions,
  buildCashFlowAccountDescriptions,
  buildIncomeStatementAccountDescriptions
} from "./accountDescriptions";
import { buildDocumentExceptions } from "./accountDocumentExceptions";
import { buildAccountFormulas } from "./accountFormulas";
import {
  buildBalanceSheetAccountHierarchy,
  buildCashFlowAccountHierarchy,
  buildIncomeStatementAccountHierarchy
} from "./accountHierarchy";
import { buildAccountValues } from "./accountValues";
import {
  buildBalanceSheetFinancialValues,
  buildCashFlowFinancialValues,
  buildIncomeStatementFinancialValues
} from "./spreadFinancialValues";

export const getIncomeStatementAccountHierarchy = createSelector(
  getSpread,
  buildIncomeStatementAccountHierarchy
);

export const getBalanceSheetAccountHierarchy = createSelector(
  getSpread,
  buildBalanceSheetAccountHierarchy
);

export const getCashFlowAccountHierarchy = createSelector(
  getSpread,
  buildCashFlowAccountHierarchy
);

export const getIncomeStatementAccountDescriptions = createSelector(
  getSpread,
  buildIncomeStatementAccountDescriptions
);

export const getBalanceSheetAccountDescriptions = createSelector(
  getSpread,
  buildBalanceSheetAccountDescriptions
);

export const getCashFlowAccountDescriptions = createSelector(
  getSpread,
  buildCashFlowAccountDescriptions
);

export const getIncomeStatementAccountFormulas = createSelector(
  getIncomeStatementAccountDescriptions,
  buildAccountFormulas
);
export const getBalanceSheetAccountFormulas = createSelector(
  getBalanceSheetAccountDescriptions,
  buildAccountFormulas
);
export const getCashFlowAccountFormulas = createSelector(
  getCashFlowAccountDescriptions,
  buildAccountFormulas
);

export const getIncomeStatementFinancialValues = createSelector(
  getSpread,
  buildIncomeStatementFinancialValues
);

export const getBalanceSheetFinancialValues = createSelector(
  getSpread,
  buildBalanceSheetFinancialValues
);

export const getCashFlowFinancialValues = createSelector(
  getSpread,
  buildCashFlowFinancialValues
);

export const getIncomeStatementAccountValues = createSelector(
  getIncomeStatementAccountHierarchy,
  getIncomeStatementAccountDescriptions,
  getIncomeStatementAccountFormulas,
  getIncomeStatementFinancialValues,
  buildAccountValues
);

export const getBalanceSheetAccountValues = createSelector(
  getBalanceSheetAccountHierarchy,
  getBalanceSheetAccountDescriptions,
  getBalanceSheetAccountFormulas,
  getBalanceSheetFinancialValues,
  buildAccountValues
);

export const getCashFlowAccountValues = createSelector(
  getCashFlowAccountHierarchy,
  getCashFlowAccountDescriptions,
  getCashFlowAccountFormulas,
  getCashFlowFinancialValues,
  buildAccountValues
);

export const getBalanceSheetDocumentExceptions = createSelector(
  getSpreadBalanceSheetDocumentExceptions,
  buildDocumentExceptions
);

export const getIncomeStatementDocumentExceptions = createSelector(
  getSpreadIncomeStatementDocumentExceptions,
  buildDocumentExceptions
);

export const getCashFlowDocumentExceptions = createSelector(
  getSpreadCashFlowDocumentExceptions,
  buildDocumentExceptions
);



// WEBPACK FOOTER //
// ./src/spread/model/derivedModel/selector.ts